import { AsyncPipe } from '@angular/common';
import { Component, inject, input, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbsenceService } from '@app/reducers/orm/absence/absence.service';
import { TranslatePipe } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { AbsenceRequestDirective } from '../../../+modals/employee/absence-request/absence-request.directive';
import { EnhancedAbsenceModel } from '../../../reducers/orm/absence/absence.model';
import {
  AbsenceSummaryItemComponent,
  EmployeePopoverData,
} from '../../../shared/absence/absence-summary-item/absence-summary-item.component';
import { SidebarHeaderComponent } from './sidebar-header.component';
import { SidebarRequestItemDirective } from './sidebar-request-item.directive';

@Component({
  selector: 'absence-request-notifications',
  templateUrl: './absence-request-notifications.component.html',
  imports: [
    AbsenceSummaryItemComponent,
    SidebarHeaderComponent,
    SidebarRequestItemDirective,
    AbsenceRequestDirective,
    AsyncPipe,
    TranslatePipe,
  ],
})
export class AbsenceRequestNotificationsComponent implements OnChanges {
  private absenceService = inject(AbsenceService);

  popoverData$: Record<string, Observable<EmployeePopoverData>> = {};

  @Input()
  absences: EnhancedAbsenceModel[];

  @Input()
  isOwnAbsences: boolean;

  showHeader = input(true);

  /** Per absence id, the other departments to mention under that absence. */
  alsoIn = input<Record<string, string>>({});

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['absences']) {
      this.absences.forEach((absence) => {
        this.popoverData$[absence.id] = this.absenceService.getPopoverData$(absence.Employee.id);
      });
    }
  }
}
